import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6" }
const _hoisted_4 = { class: "card border-0 rounded-0 bg-white authentication-card" }
const _hoisted_5 = { class: "card-body letter-spacing" }
const _hoisted_6 = { class: "text-black fw-bold mb-0 text-center" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "form-messages mt-2 px-1" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_15 = { class: "password-input" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20" }
const _hoisted_19 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_20 = { class: "password-input" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "text-center mt-15 mt-sm-20 mt-md-25" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-arrow-left" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('feature.auth.reset_password')), 1 /* TEXT */),
              _createElementVNode("p", {
                class: "mb-0 fs-md-15 fs-lg-16 text-paragraph text-center sub-text",
                innerHTML: `${_ctx.$t('feature.auth.$reset_password.message', {email: _ctx.form.identifier})}`
              }, null, 8 /* PROPS */, _hoisted_7),
              _createElementVNode("form", {
                onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('form.confirmation_code.label')) + "* ", 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    title: "Code",
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && (_ctx.errors?.code ?? false) }]]),
                    required: "",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.code) = $event)),
                    placeholder: _ctx.$t('form.confirmation_code.placeholder')
                  }, null, 10 /* CLASS, PROPS */, _hoisted_10), [
                    [_vModelText, _ctx.form.code]
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", {
                      class: "small lh-1 m-0 mt-1",
                      innerHTML: `*${ _ctx.$t('feature.auth.$reset_password.expires_in', {time: _ctx.expires_in}) }`
                    }, null, 8 /* PROPS */, _hoisted_12),
                    (_ctx.errors?.code ?? false)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errors.code, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('form.password.label')), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      title: "Password",
                      class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && !_ctx.passwordIsValid }]]),
                      required: "",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                      placeholder: _ctx.$t('form.password.placeholder')
                    }, null, 10 /* CLASS, PROPS */, _hoisted_16), [
                      [_vModelText, _ctx.form.password]
                    ]),
                    _createElementVNode("i", {
                      class: "ph ph-eye position-absolute top-0 end-0 fs-18 text-muted",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.togglePassword($event)))
                    })
                  ]),
                  (_ctx.errors?.password ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.password, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('form.password_confirmation.label')), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      title: "Password",
                      class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && (!_ctx.passwordIsValid || !_ctx.confirmPasswordIsValid) }]]),
                      required: "",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.password_confirmation) = $event)),
                      placeholder: _ctx.$t('form.password_confirmation.placeholder')
                    }, null, 10 /* CLASS, PROPS */, _hoisted_21), [
                      [_vModelText, _ctx.form.password_confirmation]
                    ]),
                    _createElementVNode("i", {
                      class: "ph ph-eye position-absolute top-0 end-0 fs-18 text-muted",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.togglePassword($event)))
                    })
                  ])
                ]),
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "default-btn transition fw-medium fs-md-15 fs-lg-16 d-block w-100",
                      type: "submit",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.setPristine && _ctx.setPristine(...args)))
                    }, _toDisplayString(_ctx.$t('feature.auth.reset_password')), 1 /* TEXT */))
                  : (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 1 })),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_router_link, {
                    to: "/login",
                    class: "link-btn text-decoration-none text-primary fw-medium fs-md-15 fs-lg-16 position-relative"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.back_to_login')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ], 32 /* NEED_HYDRATION */)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AlertModal, {
      id: "alertModal",
      onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resendRequest())),
      title: _ctx.$t('feature.auth.$reset_password.code_expired'),
      message: _ctx.$t('feature.auth.$reset_password.code_expired_message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}